<template>
    <div class="chart-legend">
        <div v-for="legend in legends"
                :key="legend.id" @click="onClickShowHideLegend(legend)" class="legend">
            <div v-if="legend.visible">
                <b-icon :style="`color:${legend.colour}`"
                        icon="circle"
                        size="is-small">
                </b-icon>{{legend.name}}
            </div>
            <div v-else :style="`color:#aaa`">
                <b-icon icon="circle"
                        size="is-small">
                </b-icon>{{legend.name}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        legends: {
            type: Array,
            required: true
        }
    },
    methods: {
        onClickShowHideLegend (legend) {
            legend.visible = !legend.visible;
        }
    }
};
</script>

<style lang="scss" scoped>
    .chart-legend {
        font-size: 10px;

        .legend {
            margin-right: 5px;
        }

        div {
            white-space: nowrap;
            float: left;
        }
        :hover{
            cursor: pointer;
        }
    }
</style>
